import { IBookingCalendarStore } from '../../index'
import { IToggleCloseModal } from '../../../../actions/bookingCalendar/reservationModal/toggleCloseModal'

export default function(
  state: IBookingCalendarStore,
  action: IToggleCloseModal,
): IBookingCalendarStore {
  return {
    ...state,
    reservationModal: {
      ...state.reservationModal,
      closeModal: {
        open: action.toggle,
      },
    },
  }
}
